export const Note = 'Note';
export const UploadFile = 'UploadFile';
export const Presenter = 'Presenter';
export const Vote = 'Vote';

export { NoteActivity } from './Note/NoteActivity';
export { UploadFileActivity } from './UploadFile/UploadFileActivity';
export { PresenterActivity } from './Presenter/PresenterActivity';
export { VoteActivity } from './Vote/VoteActivity';